import { render, staticRenderFns } from "./SharedLinkContent.vue?vue&type=template&id=eff989ca&scoped=true"
import script from "./SharedLinkContent.vue?vue&type=script&lang=ts"
export * from "./SharedLinkContent.vue?vue&type=script&lang=ts"
import style0 from "./SharedLinkContent.vue?vue&type=style&index=0&id=eff989ca&prod&lang=scss&scoped=true"
import style1 from "./SharedLinkContent.vue?vue&type=style&index=1&id=eff989ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff989ca",
  null
  
)

export default component.exports